import * as React from "react";

import type { DesignaliProps } from "../../types";

export const FileWarning = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M15,2H6c-1.1,0-2,.9-2,2v16c0,1.1.9,2,2,2h12c1.1,0,2-.9,2-2V7l-5-5Z" />
        <g>
          <line x1="12" y1="8.37" x2="12" y2="12.02" />
          <circle cx="12" cy="15.48" r=".15" />
        </g>
      </svg>
    );
  },
);

export default FileWarning;
